import { createElement } from 'react';
import './index.scss';
const ColorfulLoading = props => {
    const { isLoading, children, ...otherProps } = props;
    const prefixCls = 'au-loading';
    const _otherProps = otherProps || {};
    return (createElement("div", { className: prefixCls, ..._otherProps },
        isLoading && (createElement("div", { className: "au-loading-mask" },
            createElement("div", { className: "au-loading-tip" },
                createElement("div", { className: "au-loading-animate" },
                    createElement("span", { className: "au-loading-dot" }),
                    createElement("span", { className: "au-loading-dot" }),
                    createElement("span", { className: "au-loading-dot" }),
                    createElement("span", { className: "au-loading-dot" }))))),
        createElement("div", { className: "au-loading-content" },
            isLoading && createElement("div", { className: "au-loading-mask-bg" }),
            children)));
};
ColorfulLoading.displayName = 'ColorfulLoading';
export default ColorfulLoading;
